<template>
    <div>
        <h2>แก้ไขค่าเที่ยว</h2>
        <div class="row form-group">
            <div class="col-4 text-right">แก้ไข TN</div>
            <div class="col-6">
                <multiselect
                    v-model="form.invoices"
                    :options="optionInvoice"
                    track-by="id"
                    label="invoice_id"
                    :multiple="true"
                    :show-labels="false"
                    placeholder="เลือก TN">
                </multiselect>
            </div>
        </div>
        <div class="row form-group">
            <div class="col-4 text-right">แก้ไข วันที่</div>
            <div class="col-6">
                <date-picker placeholder="วันที่รถออก"
                             v-model="form.date"
                             :format="changeFormat"
                             :lang="lang"
                             confirm>
                </date-picker>
            </div>
        </div>
        <div class="row form-group">
            <div class="col-4 text-right">แก้ไข ค่าเที่ยว</div>
            <div class="col-6">
                <input type="number"
                       v-model="form.transport_fee_total"
                       class="form-control"/>
            </div>
        </div>
        <div class="row form-group">
            <div class="col-4 text-right">แก้ไข ค่าพ่วง</div>
            <div class="col-6">
                <input type="number"
                       v-model="form.invoice_other_fee"
                       class="form-control"/>
            </div>
        </div>
        <div class="row form-group">
            <div class="col-4 text-right">แก้ไข โบนัส</div>
            <div class="col-6">
                <input type="number"
                       v-model="form.bonus"
                       class="form-control"/>
            </div>
        </div>
        <div class="row form-group">
            <div class="col-4 text-right">
                <input id="tax" type="checkbox" :checked="form.tax > 0" v-model="status_tax"/>
                <label for="tax">แก้ไข ภาษี</label>
            </div>
            <div class="col-6">
                <input type="number"
                       disabled
                       v-model="form.tax"
                       class="form-control"/>
            </div>
        </div>
        <div class="row form-group">
            <div class="col-4 text-right">แก้ไข วันที่</div>
            <div class="col-6">
                <date-picker placeholder="วันที่บันทึก"
                             v-model="form.date_time"
                             type="datetime"
                             format="DD/MM/YYYY HH:mm:ss"
                             :lang="lang"
                             confirm>
                </date-picker>
            </div>
        </div>
        <div class="col text-center">
            <button type="button"
                    @click="submitData"
                    class="btn btn-success">
                <icon name="save" style="width: 25px"></icon>
                บันทึก
            </button>
            &nbsp&nbsp
            <button type="button"
                    @click="cancelData"
                    class="btn btn-outline-secondary">
                <icon name="times" style="width: 25px"></icon>
                ยกเลิก
            </button>
        </div>
        <div style="display: none">{{ calculateTax }}</div>
        <!--        <pre class="alert-primary">{{form}}</pre>-->
    </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import {mapState} from "vuex";
import DatePicker from 'vue2-datepicker'
import moment from 'moment';

export default {
    components: {
        Multiselect,
        DatePicker
    },
    name: "edit-driver-details-modal",
    created() {

    },
    data() {
        return {
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/'+year));
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
            status_tax: true,
        }
    },
    computed: {
        ...mapState({
            form: state => {
                return state.DriverDetails.form;
            },
            optionInvoice: state => {
                return state.DriverDetails.invoices;
            },
            user: state => {
                return state.Auth.user;
            },
        }),
        calculateTax() {
            let transport_fee_total = this.form.transport_fee_total ? this.form.transport_fee_total : 0;
            let bonus = this.form.bonus ? this.form.bonus : 0;
            let invoice_other_fee = this.form.invoice_other_fee ? this.form.invoice_other_fee : 0;
            let total = parseFloat(transport_fee_total) + parseFloat(bonus) + parseFloat(invoice_other_fee);

            return this.form.tax = total * 0.01;
        }
    },
    methods: {
        submitData() {
            let invoice_id = [];
            if (this.form.invoices.length > 0) {
                this.form.invoices.forEach(invoice => {
                    invoice_id.push(invoice.id);
                })
            }
            let data = {
                driver_details_id: this.form.id,
                invoice_id: invoice_id,
                date: this.form.date ? moment(this.form.date).format('YYYY-MM-DD') : '',
                date_time: this.form.date_time ? moment(this.form.date_time).format('YYYY-MM-DD HH:mm:ss') : '',
                transport_fee_total: this.form.transport_fee_total,
                invoice_other_fee: this.form.invoice_other_fee,
                bonus: this.form.bonus,
                tax: this.status_tax ? this.form.tax : 0,
                update_user_id: this.user.id,
            };
            //console.log(data);
            this.$emit('submit', data);
        },
        cancelData() {
            this.$emit('submit', false);
        }
    }
}
</script>

<style scoped>

</style>
